import styles from "./AdvertisingBenefits.module.scss";

const AdvertisingBenefits = () => {
  const data = [
    {
      heading: "Increase Sales:",
      points: [
        "Drive traffic and sales with targeted advertising campaigns that reach interested customers.",
        "Boost product visibility and conversions through strategic",
      ],
    },
    {
      heading: "Enhance Brand Awareness:",
      points: [
        "Build brand recognition and credibility among your target audience.",
        "Increase brand recall through consistent exposure across the platform.",
      ],
    },
    {
      heading: "Reach Target Audience:",
      points: [
        "Target specific demographics, interests, and geographic locations with precision.",
        "Tailor your advertising strategy to reach customers most likely to convert.",
      ],
    },
    {
      heading: "Flexible Budgeting:",
      points: [
        "Set your own budget and control spending based on campaign performance.",
        "Adjust bids and allocate funds according to advertising goals and ROI.",
      ],
    },
    {
      heading: "Trackable Results:",
      points: [
        "Monitor campaign performance in real-time with detailed analytics and reporting.",
        "Measure key metrics such as impressions, clicks, conversions, and return on ad spend (ROAS).",
      ],
    },
    {
      heading: "Promotional Opportunities:",
      points: [
        "Promote special offers, seasonal sales, or new product launches effectively.",
        "Maximize exposure during peak shopping seasons or promotional events.",
      ],
    },
  ];

  return (
    <section>
      <div className="fw-semibold fs-5 my-3">Advertising Benefits</div>
      <div className="bg-white p-2">
        <div className={styles["wrapper"]}>
          {data.map((item) => (
            <>
              <div className="fw-medium">{item.heading}</div>
              <ul>
                {item.points.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvertisingBenefits;